import { z } from 'zod';
import { COLLECTION_TARGET_TYPES } from './collection-target-catalog.js';

const objectIdString = z.string().trim().min(1);

export const CollectionCampaignStatusSchema = z.enum([
    'draft',
    'launching',
    'active',
    'completed',
    'cancelled',
]);

export const CollectionEntityTypeSchema = z.enum(COLLECTION_TARGET_TYPES);

const CollectionCampaignShape = z.object({
    name: z.string().trim().min(1).max(200),
    entityType: CollectionEntityTypeSchema,
    instructions: z.string().trim().max(4000).optional().default(''),
    unlimited: z.boolean().optional().default(true),
    minCount: z.number().int().min(1).max(100).nullable().optional(),
    dueDate: z.union([z.string(), z.date()]).optional().nullable(),
    assigneeUserIds: z.array(objectIdString).optional().default([]),
    assigneeUnitIds: z.array(objectIdString).optional().default([]),
    assigneeTeamIds: z.array(objectIdString).optional().default([]),
    assigneeRoleIds: z.array(objectIdString).optional().default([]),
    assignmentTemplateId: objectIdString.optional().nullable(),
});

export const CreateCollectionCampaignSchema = CollectionCampaignShape.superRefine((value, ctx) => {
    const hasAudience = (value.assigneeUserIds?.length || 0) > 0
        || (value.assigneeUnitIds?.length || 0) > 0
        || (value.assigneeTeamIds?.length || 0) > 0
        || (value.assigneeRoleIds?.length || 0) > 0
        || !!value.assignmentTemplateId;
    if (!hasAudience) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Select people, a unit, a team, a role, or an assignment template',
            path: ['assigneeUserIds'],
        });
    }
    if (value.unlimited === false && !(Number(value.minCount) >= 1)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Enter how many records each person must submit',
            path: ['minCount'],
        });
    }
});

export const UpdateCollectionCampaignSchema = CollectionCampaignShape.partial();

export const CollectionRecordCreateSchema = z.object({
    record: z.record(z.string(), z.unknown()),
    partyPayload: z.record(z.string(), z.unknown()).optional().nullable(),
});

export const CollectionRecordLinkSchema = z.object({
    entityId: objectIdString,
});
